import React, { Component } from "react";
import LanguageVersionForm from "./LanguageVersionForm"; // Re-use for editing
import TestAnswerForm from "./TestAnswerForm";
import axios from "axios";

const config = require("../config.json");

export default class LanguageVersionDisplay extends Component {
  state = {
    isEditMode: false,
    showTestAnswerForm: false,
    testAnswerError: null,
    testAnswerSuccess: null,
  };

  ADMIN_TEST_USER_ID = "admin_tester_01";
  ADMIN_TEST_USERNAME = "Admin Tester";

  toggleEditMode = () => {
    this.setState((prevState) => ({
      isEditMode: !prevState.isEditMode,
      testAnswerError: null,
      testAnswerSuccess: null,
    }));
  };

  toggleTestAnswerForm = () => {
    this.setState((prevState) => ({
      showTestAnswerForm: !prevState.showTestAnswerForm,
      testAnswerError: null,
      testAnswerSuccess: null,
    }));
  };

  handleUpdate = (formData) => {
    // The formData from LanguageVersionForm will have languageCode, title, category, status
    // We need to ensure commonQuestionId is also passed to the parent handler
    this.props.onUpdate({
      ...formData,
      commonQuestionId: this.props.languageVersion.commonQuestionId,
      createdAt: this.props.languageVersion.createdAt,
    });
    this.toggleEditMode(); // Close edit form
  };

  handleDelete = () => {
    const { languageCode, commonQuestionId } = this.props.languageVersion;
    if (
      window.confirm(
        `Are you sure you want to delete the ${languageCode} version of question ${commonQuestionId}? This will also remove associated answers and upvotes for this language version.`
      )
    ) {
      this.props.onDelete(languageCode, commonQuestionId);
    }
  };

  handleSubmitTestAnswer = async (answerText) => {
    const { languageVersion } = this.props;
    this.setState({ testAnswerError: null, testAnswerSuccess: null });

    const answerPayload = {
      questionLanguageCode: languageVersion.languageCode,
      questionCommonId: languageVersion.commonQuestionId,
      questionActiveStatus: languageVersion.status,
      userId: this.ADMIN_TEST_USER_ID,
      username: this.ADMIN_TEST_USERNAME, // Optional
      answerText: answerText,
    };

    try {
      // API endpoint for submitting an answer (needs to be created)
      // Example: POST /messageboard/answers
      await axios.post(
        `${config.api.invokeUrl}/messageboard/answers`,
        answerPayload
      );
      this.setState({
        testAnswerSuccess: "Test answer submitted successfully!",
        showTestAnswerForm: false,
      });
      // Optionally, fetch and display test answers, or just give success message.
    } catch (error) {
      console.error("Error submitting test answer:", error);
      this.setState({
        testAnswerError: `Failed to submit test answer: ${
          error.response?.data?.message || error.message
        }`,
      });
      throw error; // Re-throw to allow TestAnswerForm to stop loading
    }
  };

  render() {
    const { languageVersion } = this.props;
    const {
      isEditMode,
      showTestAnswerForm,
      testAnswerError,
      testAnswerSuccess,
    } = this.state;

    if (!languageVersion) return null;

    const formattedDate = languageVersion.createdAt
      ? new Date(languageVersion.createdAt).toLocaleDateString()
      : "N/A";

    return (
      <div
        className="mb-4 p-3"
        style={{ border: "1px solid #eee", borderRadius: "4px", padding: 10 }}
      >
        {!isEditMode ? (
          <>
            <div className="level">
              <div className="level-left">
                <div className="level-item">
                  <strong className="mr-2">
                    Language: {languageVersion.languageCode}
                  </strong>
                </div>
                <div className="level-item">
                  <span
                    className={`tag ${
                      languageVersion.status === "ACTIVE"
                        ? "is-success"
                        : "is-warning"
                    }`}
                  >
                    {languageVersion.status}
                  </span>
                </div>
              </div>
              <div className="level-right">
                <div className="buttons are-small">
                  <button
                    onClick={this.toggleEditMode}
                    className="button is-info is-outlined"
                  >
                    Edit
                  </button>
                  <button
                    onClick={this.handleDelete}
                    className="button is-danger is-outlined"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
            <p>
              <strong>Title:</strong> {languageVersion.title}
            </p>
            {languageVersion.companyId && ( // Display Company ID if present
              <p>
                <strong>Company ID:</strong> {languageVersion.companyId}
              </p>
            )}
            <p>
              <strong>Category:</strong> {languageVersion.category}
            </p>
            <p className="is-size-7">
              <em>Created: {formattedDate}</em>
            </p>
            <div className="mt-3">
              <button
                onClick={this.toggleTestAnswerForm}
                className="button is-link is-light is-small"
              >
                {showTestAnswerForm ? "Cancel Answer" : "Add Answer"}
              </button>
              {testAnswerSuccess && (
                <p className="help is-success mt-2">{testAnswerSuccess}</p>
              )}
              {testAnswerError && (
                <p className="help is-danger mt-2">{testAnswerError}</p>
              )}
              {showTestAnswerForm && (
                <TestAnswerForm
                  languageVersion={languageVersion}
                  onSubmit={this.handleSubmitTestAnswer}
                  onCancel={this.toggleTestAnswerForm}
                />
              )}
            </div>
          </>
        ) : (
          <LanguageVersionForm
            isEditMode={true}
            initialData={languageVersion} // Pass current data for editing
            onSubmit={this.handleUpdate}
            onCancel={this.toggleEditMode}
            commonQuestionId={languageVersion.commonQuestionId} // Pass commonQuestionId
          />
        )}
      </div>
    );
  }
}
